import {useEffect, useId, useState} from "react";
import {CheckIcon, ThinCloseIcon} from "../../../components/icons/material-icons";
import {CurrencyFormat, NumberToPersianLetters} from "../../../components/techaran/money";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";

export const SignTuitionModal = (props: {
    active: boolean,
    closeHandler: any,
    isSigned: boolean,
    default: number,
    current: number,
    onDone: any,
    studentId: string,
    offAmount: number,
    extraProgramCost: number,
    defaultExtraProgramCost: number
}) => {
    const [offErr, setOffErr] = useState(false);
    const offId = useId();
    const [extraPrograms, setExtraPrograms] = useState(false);
    const [offAmount, setOffPercent] = useState('0');
    useEffect(() => {
        const isActive = props.active;
        const isSigned = props.isSigned;
        const _offAmount = props.offAmount;
        const _extraProgramCost = props.extraProgramCost;
        if (isActive) {
            document.body.classList.add('body-no-scroll');
            if (isSigned) {
                setExtraPrograms(_extraProgramCost > 0);
                setOffPercent(_offAmount.toString());
            } else {
                setExtraPrograms(false);
                setOffPercent('0');
            }
            setOffErr(false);
        } else {
            document.body.classList.remove('body-no-scroll');
        }
    }, [props.active]);
    const saveChanges = () => {
        const studentId = props.studentId;
        const _off = offAmount === '' ? 0 : parseInt(offAmount);
        if (_off < 0 || _off > props.default) {
            setOffErr(true);
            return;
        }
        const _extra = extraPrograms ? props.defaultExtraProgramCost : 0;
        const total = (props.default - _off) + _extra;
        ShowProgressLoading();
        PostJSON(
            Apis.server + '/core/admins/students/tuition/set',
            {
                id: studentId,
                total: total.toString(),
                offAmount: _off.toString(),
                extraProgramCost: _extra.toString(),
            },
            true,
            (d: {
                result: string,
                reason: string | undefined,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    return;
                }
                ShowSnackbar('قرارداد تنظیم شد.', 'باشه', 5000);
                props.closeHandler();
                props.onDone();
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    return (
        <>
            <div className={"web-modal-overlay" + (props.active ? ' active' : '')} onClick={props.closeHandler}/>
            <div className={"web-modal" + (props.active ? ' active' : '')} style={{top: 20}}>
                <div className="web-modal-header">
                    <div>
                        <b>تنظیم قرارداد شهریه</b>
                    </div>
                    <button onClick={props.closeHandler}><ThinCloseIcon/></button>
                </div>
                <div className="web-modal-body">
                    <div className="add-student">
                        <label>مبلغ نهایی شهریه:</label>
                        <span style={{
                            display: 'block',
                            margin: '5px 0 0 0',
                            fontWeight: 400,
                            color: '#0a53be'
                        }}>
                            {
                                NumberToPersianLetters(
                                    (props.default - (offAmount === '' ? 0 : parseInt(offAmount))) +
                                    (extraPrograms ? props.defaultExtraProgramCost : 0)
                                ) + " تومان"
                            }
                        </span>
                        <div style={{height: 20}}/>
                        <label htmlFor={offId}>مبلغ تخفیف:</label>
                        <input
                            type="number"
                            min={0}
                            max={100}
                            className={"form-control" + (offErr ? ' is-invalid' : '')}
                            value={offAmount}
                            onChange={e => {
                                const t = e.currentTarget.value;
                                setOffPercent(t);
                                setOffErr(false);
                            }}
                        />
                        <div className={"invalid-feedback " + (offErr ? 'd-block' : 'd-none')}>
                            لطفا یک مبلغ صحیح وارد کنید.
                        </div>
                        <div style={{height: 20}}/>
                        <button className={"techaran-checkbox" + (extraPrograms ? ' active' : '')}
                                onClick={() => setExtraPrograms(v => !v)}>
                            <i><CheckIcon/></i>
                            <span>
                                فوق برنامه
                                <em>مبلغ {CurrencyFormat(props.defaultExtraProgramCost)} تومان اضافه می‌شود.</em>
                            </span>
                        </button>
                        <div className="d-flex justify-content-end align-items-center"
                             style={{gap: 20, marginTop: 30}}>
                            <button className="cancel-button" onClick={props.closeHandler}>
                                <b>انصراف</b>
                            </button>
                            <button className="btn-pay" onClick={saveChanges}>
                                <b>ذخیره تغییرات</b>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};